/* src/app/modules/taxes/model-193/model-193-recipient-dialog/model-193-recipient-dialog.component.css */
:host {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  min-width: 0;
}
.m193d-header-text {
  min-width: 0;
  padding-right: 32px;
}
.m193d-fs {
  border: 0;
  margin: 0;
  padding: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.m193d-vistas {
  display: flex;
  gap: 4px;
  margin-bottom: 14px;
  border-bottom: 1px solid var(--cf-border);
}
.m193d-vista {
  padding: 8px 16px;
  border: 0;
  border-bottom: 3px solid transparent;
  background: none;
  font-size: 13.5px;
  font-weight: 600;
  color: var(--cf-text-muted);
  cursor: pointer;
}
.m193d-vista--activa {
  color: var(--cf-text);
  border-bottom-color: var(--cf-brand);
}
.m193d-box {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px 14px 14px;
  border: 1px solid var(--cf-border);
  border-radius: var(--cf-radius);
  background: var(--cf-bg);
}
.m193d-subbox {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px 12px 12px;
  border: 1px solid var(--cf-border);
  border-radius: var(--cf-radius);
  background: var(--cf-surface);
}
.m193d-box__title {
  margin: 0;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.4;
  color: var(--cf-brand-dark);
}
.m193d-grid {
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  gap: 6px 12px;
  align-items: end;
}
.m193d-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}
.m193d-field ::ng-deep .mb-3 {
  margin-bottom: 0 !important;
}
.m193d-fila {
  align-self: center;
  font-size: 13px;
  color: var(--cf-text);
}
.m193d-aviso {
  color: #b45309;
}
.m193d-alert {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 12px;
  padding: 10px 14px;
  border: 1px solid #fecaca;
  border-left: 4px solid var(--cf-error);
  border-radius: var(--cf-radius);
  background: #fef2f2;
  font-size: 13px;
  color: var(--cf-text);
}
.m193d-alert mat-icon {
  flex: 0 0 auto;
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: var(--cf-error);
}
@media (max-width: 768px) {
  .m193d-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .m193d-grid > * {
    grid-column: span 1 !important;
  }
}
.m193d-alert--warning {
  border-color: #fde68a;
  border-left-color: var(--cf-warning);
  background: #fffbeb;
}
.m193d-alert--warning mat-icon {
  color: var(--cf-warning);
}
/*# sourceMappingURL=model-193-recipient-dialog.component.css.map */
